<template>
  <centered-component>
    <div
      :class="{ success: items.total > 0, warning: items.total === 0}"
      class="ui compact message"
      style="margin: 1em 0;">
      <i
        v-if="items.total > 0"
        class="users icon"/>
      <i
        v-else
        class="question circle icon"/>
      <span v-if="query.search">
        {{ $tc(`${type.toLowerCase()}sSearch.specific`, items.total, { msg: query.search }) }}
      </span>
      <span v-else>
        {{ $tc(`${type.toLowerCase()}sSearch.total`, items.total) }}
      </span>
      <span v-if="pages">{{ $tc( 'search.page', pages) }}</span>
    </div>
  </centered-component>
</template>

<script>
import CenteredComponent from './utility/CenteredComponent'

export default {
  name: 'SearchSummary',
  components: { CenteredComponent },
  props: {
    type: {
      type: String,
      required: true
    },
    items: {
      type: Object,
      required: true
    },
    query: {
      type: Object,
      required: true
    }
  },
  computed: {
    pages () {
      return Math.ceil(this.items.total / this.items.limit)
    }
  }
}
</script>

<style scoped>

</style>
